"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DepartmentsDropdown = _interopRequireDefault(require("../../CRM/Dialer/DepartmentsDropdown"));
var _Dial = _interopRequireDefault(require("../../CRM/Dialer/Dial"));
var _Timer = _interopRequireDefault(require("../../Timer"));
var _Button = _interopRequireDefault(require("../../Button"));
var _RoundButton = _interopRequireDefault(require("../../CRM/Dialer/RoundButton"));
var _RoundButton2 = require("../../CRM/Dialer/RoundButton/RoundButton");
var _OperatorsDropdown = _interopRequireDefault(require("../../CRM/Dialer/OperatorsDropdown"));
var _States = _interopRequireDefault(require("../States"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CallIcon = function CallIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#FFF",
    d: "M15.89 1.404c.604.54.984.879 1.138 1.019.86.766 1 1.85.417 3.25-.874 2.102-4.151 7.17-11.288 11.453-1.575 1.108-2.99.858-3.64 0a88.726 88.726 0 0 0-1.273-1.643c-.462-.714-.268-1.376.583-1.987 1.277-.917.87-.594 1.912-1.309 1.043-.715 1.034-.555 2.418 0 1.383.556 1.396 1.04 2.767-.269.914-.872 2.084-2.064 3.512-3.575.536-.504.536-1.132 0-1.884-.803-1.129-.803-1.563 0-2.8a23.43 23.43 0 0 1 1.654-2.255c.595-.539 1.195-.539 1.8 0z"
  }));
};
CallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 19"
};
var ActiveState = /*#__PURE__*/function (_React$Component) {
  function ActiveState() {
    (0, _classCallCheck2["default"])(this, ActiveState);
    return _callSuper(this, ActiveState, arguments);
  }
  (0, _inherits2["default"])(ActiveState, _React$Component);
  return (0, _createClass2["default"])(ActiveState, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        state = _this$props.state,
        className = _this$props.className,
        isHold = _this$props.isHold,
        isVoteNeed = _this$props.isVoteNeed,
        operators = _this$props.operators,
        departments = _this$props.departments,
        isInterception = _this$props.isInterception,
        isTransfering = _this$props.isTransfering,
        isSupervising = _this$props.isSupervising,
        isSupervisor = _this$props.isSupervisor,
        isDeanonymised = _this$props.isDeanonymised,
        isRequestingHelp = _this$props.isRequestingHelp,
        contact = _this$props.contact,
        serverError = _this$props.serverError,
        onHangup = _this$props.onHangup,
        onHold = _this$props.onHold,
        onCall = _this$props.onCall,
        onListen = _this$props.onListen,
        onRequestHelp = _this$props.onRequestHelp,
        onTone = _this$props.onTone,
        onTransfer = _this$props.onTransfer,
        onConnectSupervisor = _this$props.onConnectSupervisor,
        onDeaninomize = _this$props.onDeaninomize,
        onWithdraw = _this$props.onWithdraw,
        onCancelHelpRequest = _this$props.onCancelHelpRequest,
        onOperatorsToggle = _this$props.onOperatorsToggle,
        onDepartmentsToggle = _this$props.onDepartmentsToggle,
        onOpenCall = _this$props.onOpenCall;
      return /*#__PURE__*/_react["default"].createElement(StyledActiveState, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(StyledDescription, null, /*#__PURE__*/_react["default"].createElement(StyledStatus, null, /*#__PURE__*/_react["default"].createElement(StyledIndicator, {
        status: _States["default"].READY
      }), /*#__PURE__*/_react["default"].createElement(StyledTimer, null)), /*#__PURE__*/_react["default"].createElement(StyledContact, null, /*#__PURE__*/_react["default"].createElement(CallIcon, {
        width: 19
      }), /*#__PURE__*/_react["default"].createElement(StyledName, null, contact.fullName || contact.number))), /*#__PURE__*/_react["default"].createElement(StyledControlItems, null, /*#__PURE__*/_react["default"].createElement(StyledControls, null, !isInterception && !isDeanonymised && !isRequestingHelp && /*#__PURE__*/_react["default"].createElement(StyledHolder, {
        active: isHold,
        actionType: _RoundButton2.Types.HOLD,
        onClick: function onClick() {
          return onHold(!isHold);
        }
      }), isRequestingHelp && /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], {
        pulsing: isRequestingHelp,
        onClick: onCancelHelpRequest,
        actionType: _RoundButton2.Types.HELPER
      }), isDeanonymised && !isSupervisor && /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], {
        active: isSupervising,
        pulsing: !isSupervising,
        actionType: _RoundButton2.Types.SUPERVISOR,
        onClick: function onClick() {
          return onConnectSupervisor(!isSupervising);
        }
      }), /*#__PURE__*/_react["default"].createElement(StyledHang, null, /*#__PURE__*/_react["default"].createElement(StyledHangupIcon, {
        actionType: _RoundButton2.Types.END_CALL,
        onClick: onHangup
      }), isVoteNeed && /*#__PURE__*/_react["default"].createElement(StyledVoteWarning, null, "\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0434\u0438\u0442\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u0447\u0442\u043E \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0430, \u043E\u043D \u0441\u043C\u043E\u0436\u0435\u0442 \u043E\u0446\u0435\u043D\u0438\u0442\u044C \u0441\u0435\u0440\u0432\u0438\u0441")), !isInterception && /*#__PURE__*/_react["default"].createElement(_Dial["default"], {
        onTone: onTone
      }), !isInterception && !isTransfering && /*#__PURE__*/_react["default"].createElement(StyledControls, null, /*#__PURE__*/_react["default"].createElement(_DepartmentsDropdown["default"], {
        departments: departments,
        onChange: onTransfer,
        onToggle: onDepartmentsToggle
      }), /*#__PURE__*/_react["default"].createElement(_OperatorsDropdown["default"], {
        state: state,
        onCall: onCall,
        onTransfer: onTransfer,
        onListen: onListen,
        onRequestHelp: onRequestHelp,
        onToggle: onOperatorsToggle,
        operators: operators,
        placeholder: "\u041D\u0430 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430"
      })), isInterception && isSupervisor && /*#__PURE__*/_react["default"].createElement(StyledControls, null, /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], {
        actionType: _RoundButton2.Types.WITHDRAW,
        onClick: onWithdraw
      }), /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], {
        active: isSupervising,
        actionType: _RoundButton2.Types.MIC,
        onClick: function onClick() {
          return onConnectSupervisor(!isSupervising);
        }
      }), /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], {
        active: isDeanonymised,
        onClick: isDeanonymised ? function () {
          return onConnectSupervisor(false);
        } : function () {
          return onDeaninomize(!isDeanonymised);
        },
        actionType: _RoundButton2.Types.ANONIMIZER
      })), serverError && /*#__PURE__*/_react["default"].createElement(StyledServerError, null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u044B \u0441 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u043C"), /*#__PURE__*/_react["default"].createElement("br", null), "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0443\u0436\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430\u0434 \u0438\u0445 \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u043C.")))), onOpenCall && /*#__PURE__*/_react["default"].createElement(StyledOpenCall, {
        functional: true,
        onClick: onOpenCall
      }, "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0437\u0432\u043E\u043D\u043E\u043A"));
    }
  }]);
}(_react["default"].Component);
ActiveState.propTypes = {
  state: _propTypes["default"].oneOf(Object.values(_States["default"])),
  className: _propTypes["default"].string,
  isHold: _propTypes["default"].bool,
  isDeanonymised: _propTypes["default"].bool,
  isInterception: _propTypes["default"].bool,
  isRequestingHelp: _propTypes["default"].bool,
  isTransfering: _propTypes["default"].bool.isRequired,
  isSupervising: _propTypes["default"].bool,
  isSupervisor: _propTypes["default"].bool,
  isVoteNeed: _propTypes["default"].bool,
  serverError: _propTypes["default"].bool,
  onHangup: _propTypes["default"].func,
  onWithdraw: _propTypes["default"].func,
  onCancelHelpRequest: _propTypes["default"].func,
  onHold: _propTypes["default"].func,
  onConnectSupervisor: _propTypes["default"].func,
  onTone: _propTypes["default"].func,
  onTransfer: _propTypes["default"].func,
  onDeaninomize: _propTypes["default"].func,
  onCall: _propTypes["default"].func,
  onListen: _propTypes["default"].func,
  onRequestHelp: _propTypes["default"].func,
  onOperatorsToggle: _propTypes["default"].func,
  onDepartmentsToggle: _propTypes["default"].func,
  onOpenCall: _propTypes["default"].func,
  contact: _propTypes["default"].shape({
    fullName: _propTypes["default"].string,
    number: _propTypes["default"].number
  }),
  departments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    svg: _propTypes["default"].shape({}),
    isReserve: _propTypes["default"].bool,
    value: _propTypes["default"].string.isRequired
  })).isRequired,
  operators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    call: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      duration: _propTypes["default"].number
    }),
    contact: _propTypes["default"].shape({
      name: _propTypes["default"].string,
      number: _propTypes["default"].number,
      isHidden: _propTypes["default"].bool
    }),
    operator: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      number: _propTypes["default"].string.isRequired,
      skillGroups: _propTypes["default"].arrayOf(_propTypes["default"].string),
      canCall: _propTypes["default"].bool.isRequired,
      canTransfer: _propTypes["default"].bool.isRequired,
      canListen: _propTypes["default"].bool.isRequired,
      canRequestHelp: _propTypes["default"].bool.isRequired
    }).isRequired,
    state: _propTypes["default"].string
  })).isRequired
};
ActiveState.defaultProps = {
  className: '',
  state: _States["default"].OFFLINE,
  contact: null,
  isHold: false,
  isInterception: false,
  isSupervising: false,
  isSupervisor: false,
  isDeanonymised: false,
  isRequestingHelp: false,
  isVoteNeed: false,
  serverError: false,
  onHangup: Function.prototype,
  onWithdraw: Function.prototype,
  onCancelHelpRequest: Function.prototype,
  onHold: Function.prototype,
  onConnectSupervisor: Function.prototype,
  onTone: Function.prototype,
  onTransfer: Function.prototype,
  onDeaninomize: Function.prototype,
  onCall: Function.prototype,
  onListen: Function.prototype,
  onRequestHelp: Function.prototype,
  onOperatorsToggle: Function.prototype,
  onDepartmentsToggle: Function.prototype,
  onOpenCall: Function.prototype
};
var StyledFlex = _styledComponents["default"].div.withConfig({
  displayName: "Active__StyledFlex",
  componentId: "sc-1wsu3df-0"
})(["display:flex;align-items:center;"]);
var StyledControlItems = _styledComponents["default"].div.withConfig({
  displayName: "Active__StyledControlItems",
  componentId: "sc-1wsu3df-1"
})(["flex:1;"]);
var StyledActiveState = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "Active__StyledActiveState",
  componentId: "sc-1wsu3df-2"
})(["height:100%;width:100%;> * + *{margin-left:10px;}"]);
var StyledOpenCall = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Active__StyledOpenCall",
  componentId: "sc-1wsu3df-3"
})(["background-image:linear-gradient( 90deg,transparent,rgba(255,255,255,0.2) );font-size:13px;color:white;font-weight:500;padding:0 33px;min-height:65px;"]);
var StyledDescription = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "Active__StyledDescription",
  componentId: "sc-1wsu3df-4"
})(["color:white;min-width:236px;> * + *{margin-left:9px;}"]);
var StyledStatus = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "Active__StyledStatus",
  componentId: "sc-1wsu3df-5"
})(["min-width:65px;> * + *{margin-left:5px;}"]);
var StyledIndicator = _styledComponents["default"].div.withConfig({
  displayName: "Active__StyledIndicator",
  componentId: "sc-1wsu3df-6"
})(["width:14px;height:14px;flex-shrink:0;border-radius:50%;background-image:linear-gradient(to top,#00b0b6,#00e04b);"]);
var StyledTimer = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "Active__StyledTimer",
  componentId: "sc-1wsu3df-7"
})(["color:#919499;font-size:14px;margin-top:1px;user-select:none;font-weight:normal;"]);
var StyledHolder = (0, _styledComponents["default"])(_RoundButton["default"]).withConfig({
  displayName: "Active__StyledHolder",
  componentId: "sc-1wsu3df-8"
})(["min-width:40px;"]);
var StyledHang = _styledComponents["default"].div.withConfig({
  displayName: "Active__StyledHang",
  componentId: "sc-1wsu3df-9"
})(["position:relative;"]);
var StyledHangupIcon = (0, _styledComponents["default"])(_RoundButton["default"]).withConfig({
  displayName: "Active__StyledHangupIcon",
  componentId: "sc-1wsu3df-10"
})(["border:none;"]);
var StyledVoteWarning = _styledComponents["default"].div.withConfig({
  displayName: "Active__StyledVoteWarning",
  componentId: "sc-1wsu3df-11"
})(["width:330px;box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);background-color:#f8e71c;position:absolute;top:0;margin-top:-61px;margin-left:-149px;border-radius:6px;padding:11px 10px;font-size:14px;z-index:99;text-align:center;&:after{content:'';width:0;height:0;border-left:10px solid #0000;border-right:10px solid #0000;border-top:10px solid #f8e71c;position:absolute;bottom:-10px;left:160px;}"]);
var StyledContact = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "Active__StyledContact",
  componentId: "sc-1wsu3df-12"
})(["max-width:220px;> * + *{margin-left:7px;}"]);
var StyledName = _styledComponents["default"].span.withConfig({
  displayName: "Active__StyledName",
  componentId: "sc-1wsu3df-13"
})(["color:#fff;font-size:14px;margin-top:1px;overflow:hidden;font-weight:500;white-space:nowrap;text-overflow:ellipsis;"]);
var StyledControls = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "Active__StyledControls",
  componentId: "sc-1wsu3df-14"
})(["> * + *{margin-left:12px;}"]);
var StyledServerError = _styledComponents["default"].div.withConfig({
  displayName: "Active__StyledServerError",
  componentId: "sc-1wsu3df-15"
})(["color:white;height:65px;display:flex;justify-content:center;align-items:center;background:radial-gradient(29.25% 121.54% at 47.17% 0%,#7E3535 0%,transparent 100%);"]);
var _default = exports["default"] = ActiveState;